import { BidAwardLockup } from '@tempmee/react';
import { Divider } from '~/commonComponents';
import { BestInDentalV2 } from '~/constants/ff.posthog';
import { useBidWinnerRecognition } from '~/domain/BestInDental';
import { useFeatureFlag } from '~/hooks/useFeatureFlag';
import { useUserSelector } from '~/hooks/useUserSelector';

/**
 * Best-in-Dental winner credential on the Account header.
 *
 * Flag ON: driven by awards-service data (the same `useBidWinnerRecognition`
 * source as the dashboard `BidWinnerBanner`). Flag OFF: falls back to the
 * legacy `/auth/me` winner blob, so offices that already won keep the badge
 * through the two-phase rollout — the merge ships flag-off, and losing the
 * credential until the flag flips would be a regression. Both sources render
 * the same DS award lockup.
 */
export const BestInDentalWinner = () => {
  const isFlagOn = useFeatureFlag(BestInDentalV2);
  const { isEverWinner, currentCycleWin, isLoading } = useBidWinnerRecognition(isFlagOn);
  const currentUser = useUserSelector();

  const legacyBid = currentUser?.office_info?.bestInDental;
  const legacyYear = legacyBid?.winnerDetails?.[0]?.winningYear;

  const isWinner = isFlagOn ? !isLoading && isEverWinner : legacyBid?.status === 'winner';
  const year = isFlagOn ? currentCycleWin?.cycleYear : legacyYear;

  if (!isWinner) {
    return null;
  }

  return (
    <>
      <Divider width={1} height="50%" />
      <BidAwardLockup
        elevated
        layout="split"
        label="Best in Dental"
        year={year != null ? Number(year) : undefined}
        data-cy="bid-profile-winner"
      />
    </>
  );
};
